import React from "react";
import Modal from "react-bootstrap/Modal";
import styled from "styled-components";

/**
 * One value, one list, one tap.
 *
 * The sheet's own pickers (ModalSpecsheets) cover forty-one fields, but the
 * bowler's style, axis numbers, speed and rev rate are not among them -- they
 * belong to the person, not the sheet, and on the bowler screen they are
 * edited through a modal that writes straight to the live customer record.
 * The review has no customer to write to yet, so it needs its own.
 *
 * Deliberately a popover rather than a screen: it is the same idea as the
 * pickers beside it, and it is what makes the chips behave like the chips on
 * a bowler's header instead of a row of dropdowns.
 */

const Title = styled.div`
  color: #00187e;
  font-weight: 700;
  font-size: 16px;
`;

const Options = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 8px;
`;

const Option = styled.button`
  /* Touch-first: tapped on a tablet at a shop counter. */
  min-height: 48px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.$on ? "#00187e" : "#c3c7d4")};
  background: ${(p) => (p.$on ? "#00187e" : "#ffffff")};
  color: ${(p) => (p.$on ? "#ffffff" : "#00187e")};
  font-size: 14px;
  font-weight: 600;

  &:hover {
    background: ${(p) => (p.$on ? "#001463" : "rgba(0, 24, 126, 0.08)")};
  }
`;

const Blank = styled.span`
  color: #9aa0ad;
  font-style: italic;
  font-weight: 500;
`;

const ScanValuePicker = ({
  show,
  title,
  options = [],
  value = "",
  blankLabel,
  onPick,
  onClose,
}) => (
  <Modal show={show} onHide={onClose} centered className="select-modal">
    <Modal.Header closeButton>
      <Title>{title}</Title>
    </Modal.Header>
    <Modal.Body>
      <Options>
        {options.map((option) => (
          <Option
            key={option || "__blank"}
            type="button"
            $on={option === value}
            onClick={() => {
              onPick(option);
              onClose();
            }}
          >
            {option === "" ? <Blank>{blankLabel}</Blank> : option}
          </Option>
        ))}
      </Options>
    </Modal.Body>
  </Modal>
);

export default ScanValuePicker;
